import Vue from "vue"
import Router from "vue-router"
import store from "@/store/index.js"
import routes from "@/router/routes/index.js"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/",
      redirect: "/dashboard"
    }
  ].concat(routes)
})

router.beforeEach((to, from, next) => {
  const authenticated = store.state.authenticated
  const isAll = to.matched.some(record => record.meta.all)
  const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut)
  const isPublic = to.matched.some(record => record.meta.public)
  const isNotAllowedPage = to.path === '/not-allowed'
  const userRole = store.state.user && store.state.user.role ? store.state.user.role : ''
  const isBpkpad = userRole === 'bpkpad'
  const isKadis = userRole === 'kadis'
  const allowBpkpadPaths = ['/order', '/profile', '/dashboard']
  const allowKadisPaths = ['/tandatangan', '/profile', '/dashboard', '/statistik', '/log-esign']
  
  if (!isAll && !isPublic && !authenticated) {
    return next({
      path: "/login"
    })
  }
  if (authenticated && onlyLoggedOut) {
    return next("/")
  }
  if (isBpkpad && !isNotAllowedPage) {
    const isAllowed = allowBpkpadPaths.some(path => to.path.startsWith(path))
    if (!isAllowed) {
      return next('/not-allowed')
    }
  }
  if (isKadis && !isNotAllowedPage) {
    const isAllowed = allowKadisPaths.some(path => to.path.startsWith(path))
    if (!isAllowed) {
      return next('/not-allowed')
    }
  }
  document.title = `${to.meta.title} | Disperakim Kabupaten Klaten`;
  next()
})

export default router